import { render, staticRenderFns } from "./user_product_bundles_active.vue?vue&type=template&id=59bc30e1&scoped=true"
import script from "./user_product_bundles_active.vue?vue&type=script&lang=js"
export * from "./user_product_bundles_active.vue?vue&type=script&lang=js"
import style0 from "./user_product_bundles_active.vue?vue&type=style&index=0&id=59bc30e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc30e1",
  null
  
)

export default component.exports